import React from 'react';
import { ProcessorCallList } from './pages/ProcessorCallList';
export function App() {
  return <ProcessorCallList data-id="element-0" />;
}